/**
 * Logout Confirmation Modal
 * Modal to confirm user logout action using shadcn Dialog
 */

import { X } from "lucide-react"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useTranslation } from "@/language"

interface LogoutConfirmationModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export function LogoutConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
}: LogoutConfirmationModalProps) {
  const { t } = useTranslation("common")

  return (
    <Dialog open={isOpen} onOpenChange={(open: boolean) => !open && onClose()}>
      <DialogContent
        showCloseButton={false}
        overlayClass="bg-[#020202E5]"
        className="md:w-[520px] bg-[#020202] border-[#F2F0EB4D] gap-7.5 pt-[50px] pb-[40px] px-[20px] md:px-[50px]"
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute right-4 top-4 text-[#F2F0EB] bg-[#F2F0EB0D] border border-[#F2F0EB26] p-2.5 rounded-full transition-opacity hover:opacity-100 focus:outline-none border-gradient-3d cursor-pointer"
        >
          <X className="h-4 w-4" />
        </button>
        <DialogHeader className="text-center gap-2.5">
          <DialogTitle className="text-[#F2F0EBE6] text-xl font-semibold text-center leading-6">
            {t("logoutModal.title")}
          </DialogTitle>
          <DialogDescription className="text-[#F2F0EBE6] text-center text-sm font-normal leading-[17px]">
            {t("logoutModal.description")}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex-row gap-2.5 sm:flex-row">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1 h-[50px] md:w-[205px] uppercase"
          >
            {t("logoutModal.stay")}
          </Button>
          <Button
            variant="ghost"
            onClick={onConfirm}
            className="flex-1 h-[50px]  md:w-[205px] uppercase border border-brand-terracotta bg-transparent !text-brand-terracotta !hover:text-brand-terracotta hover:bg-transparent"
          >
            {t("logoutModal.logOut")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
